import rootReducer from "./reducer";
import { RESET_APP_STATE } from "./actions";
import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
require('dotenv').config();
let middlewares = [];

middlewares = middlewares.concat(thunk);

if (process.env.NODE_ENV === "development") {
  const { logger } = require("redux-logger");
  middlewares = middlewares.concat(logger);
}

const combinedReducer = combineReducers({
  ...rootReducer,
});

const rootReducerWithReset = (state, action) => {
  if (action.type === RESET_APP_STATE) {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

const store = createStore(rootReducerWithReset, applyMiddleware(...middlewares));

export default store
